export const version = `v2.2.40 08/14/26 11:36pm`;